export type TrackingAttributes = Readonly<Record<string, string>>

/**
 * posthog-js autocapture reads `data-ph-capture-attribute-<name>` from every element in the clicked element's ancestor
 * chain, and turns each one into a `<name>` property on the `$autocapture` event.
 */
export function toPostHogCaptureAttributes(attributes: TrackingAttributes | undefined): Record<string, string> {
  if (!attributes) return {}
  return Object.fromEntries(
    Object.entries(attributes).map(([name, value]) => [`data-ph-capture-attribute-${name}`, value]),
  )
}
